import React from 'react';

import Grid from '@material-ui/core/Grid';

import DashboardTable from '../../../../../../components/DashboardTable';
import {TRANSACTION_TYPE_VALUES} from "../../../../constants";
import {
  TRADING_ACTION_SAVINGS_PLAN, TRADING_ACTION_PAYOUT_PLAN, TRADING_ACTION_SELL, TRADING_ACTION_BUY,
} from "../../../../../../components/Charts/InstrumentsAllocationTable/constants";
import ConfirmationHeader from "./components/ConfirmationHeader";
import {
  paymentPlansConfirmationTableStructure,
  paymentPlansConfirmationTableStructureForMP
} from "./components/confirmationTableColumns";
import useStyles from "./components/singleInvestmentTableStyles";


/**
 * Prepare flat list of payment plan transactions with order numbers.
 * Switch plans: flatten switch-out + switch-in items.
 */
const preparePaymentPlanTransactions = (transactions) => {
  const allItems = [];

  // Savings plans
  (transactions[TRANSACTION_TYPE_VALUES.SAVINGS_PLAN] || []).forEach(item => {
    allItems.push({
      ...item,
      tradingType: TRADING_ACTION_SAVINGS_PLAN,
    });
  });

  // Payout plans
  (transactions[TRANSACTION_TYPE_VALUES.PAYOUT_PLAN] || []).forEach(item => {
    allItems.push({
      ...item,
      tradingType: TRADING_ACTION_PAYOUT_PLAN,
    });
  });

  // Switch plans: flatten switch-out + switch-in
  (transactions[TRANSACTION_TYPE_VALUES.SWITCH_PLAN] || []).forEach(switchOut => {
    allItems.push({
      ...switchOut,
      isSwitchOutItem: true,
      tradingType: TRADING_ACTION_SELL,
    });
    (switchOut.buy || []).forEach(switchIn => {
      allItems.push({
        ...switchIn,
        tradingType: TRADING_ACTION_BUY,
        isSwitchInItem: true,
        switchOutItem: switchOut,
      });
    });
  });

  // Assign order numbers — only non-switch-in items get numbered
  let orderNumber = 1;
  allItems.forEach(item => {
    if (!item.isSwitchInItem) {
      item._orderNumber = orderNumber++;
    }
  });

  return allItems;
};

/**
 * Displays the payment plan (savings_plan/payout_plan/switch_plan) transactions
 * for a single portfolio as a read-only confirmation table.
 */
function PaymentPlansStep(props) {
  const {
    questions: [question],
    dataService,
  } = props;

  const classes = useStyles();

  const portfolio = question.portfolio;

  if (!portfolio) {
    return null;
  }

  const dataSource = React.useMemo(
    () => preparePaymentPlanTransactions(portfolio.transactions),
    [portfolio.transactions]
  );

  const tableOptions = React.useMemo(() => ({
    maxQtyDecimals: portfolio.maxQtyDecimals,
    isModelportfolio: portfolio.isModelportfolio,
    modelPortfolioTransactionType: portfolio.modelPortfolioTransactionType,
    combinedDiscounts: portfolio.combinedDiscounts,
    depotDiscount: portfolio.discount,
  }), [portfolio]);

  return (
    <Grid container spacing={3}>
      <ConfirmationHeader stepName={dataService.step.category} />
      <Grid item xs={12} className={classes.tableContainer}>
        <DashboardTable
          tableLayout={"auto"}
          structure={portfolio.isModelportfolio ? paymentPlansConfirmationTableStructureForMP : paymentPlansConfirmationTableStructure}
          dataSource={dataSource}
          expanded={true}
          tableClasses={classes}
          withFooter={true}
          options={tableOptions}
        />
      </Grid>
    </Grid>
  );
}

export default PaymentPlansStep;
